import { render, staticRenderFns } from "./NotasVista.vue?vue&type=template&id=2dd2e954&"
import script from "./NotasVista.vue?vue&type=script&lang=js&"
export * from "./NotasVista.vue?vue&type=script&lang=js&"
import style0 from "./NotasVista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
